// Centralized AI Service
import { apiClient } from '../config/api.js';
import { getModelConfig, MODEL_CONFIGS } from '../config/models.js';

class AIService {
    constructor() {
        this.defaultModel = 'gpt-3.5-turbo';
    }

    /**
     * Generate content using AI
     * @param {string} prompt - The prompt to send to the AI
     * @param {string} taskType - Type of task (GUEST_ANALYSIS, CONTENT_GENERATION, etc.)
     * @param {object} options - Additional options
     * @returns {Promise<string>} - Generated content
     */
    async generateContent(prompt, taskType = 'GENERAL', options = {}) {
        try {
            // Get model configuration based on task type
            const modelConfig = MODEL_CONFIGS[taskType] || MODEL_CONFIGS.CONTENT_GENERATION;
            
            // Filter only valid OpenAI API parameters
            const validOptions = {
                temperature: modelConfig.temperature,
                max_tokens: modelConfig.max_tokens,
                ...options
            };


            const result = await apiClient.generateContent(prompt, modelConfig.model, validOptions);
            
            return result;
        } catch (error) {
            throw new Error(`AI generation failed: ${error.message}`);
        }
    }

    /**
     * Generate content with specific model
     * @param {string} prompt - The prompt to send to the AI
     * @param {string} modelName - Specific model to use
     * @param {object} options - Additional options
     * @returns {Promise<string>} - Generated content
     */
    async generateWithModel(prompt, modelName, options = {}) {
        try {
            const modelConfig = getModelConfig(modelName);
            

            const result = await apiClient.generateContent(prompt, modelConfig.model, {
                ...modelConfig,
                ...options
            });
            
            return result;
        } catch (error) {
            throw new Error(`AI generation failed: ${error.message}`);
        }
    }

    /**
     * Legacy method for backward compatibility
     * @param {string} prompt - The prompt to send to the AI
     * @returns {Promise<string>} - Generated content
     */
    async generateWithOpenAI(prompt) {
        return this.generateContent(prompt, 'GENERAL');
    }
}

// Create singleton instance
const aiService = new AIService();

export default aiService; 